export default "__VITE_ASSET__c45eda9b__"